export enum WeaponType {
  Gun = 'gun',
  Bow = 'bow',
  Muzzleloader = 'muzzleloader',
  Crossbow = 'crossbow',
  Youth = 'youth',
  Other = 'other',
  Any = 'any',
}

export interface Season {
  id: string;
  userId: string; // FK → User
  name: string; // e.g., "2026 WI Gun Deer"
  state: string;
  weaponType: WeaponType;
  openerDate: string; // ISO 8601 date (YYYY-MM-DD)
  closerDate?: string;
  isPrimary?: boolean; // true on the one season driving the CountdownWidget
  createdAt: string;
  updatedAt: string;
}

// userId is auto-set by the adapter
export type CreateSeasonInput = Omit<Season, 'id' | 'userId' | 'createdAt' | 'updatedAt'>;
export type UpdateSeasonInput = Partial<CreateSeasonInput>;
